export var WalletName;
(function (WalletName) {
    // BitKeep = 'BitKeep', // not published yet
    WalletName["Bitpie"] = "Bitpie";
    WalletName["Blocto"] = "Blocto";
    WalletName["Clover"] = "Clover";
    WalletName["Coin98"] = "Coin98";
    WalletName["Ledger"] = "Ledger";
    WalletName["MathWallet"] = "MathWallet";
    WalletName["Phantom"] = "Phantom";
    WalletName["SafePal"] = "SafePal";
    WalletName["Slope"] = "Slope";
    WalletName["Solflare"] = "Solflare";
    WalletName["SolflareWeb"] = "Solflare (Web)";
    WalletName["Sollet"] = "Sollet";
    WalletName["SolletExtension"] = "Sollet (Extension)";
    WalletName["Solong"] = "Solong";
    WalletName["Torus"] = "Torus";
    // WalletConnect = 'WalletConnect', // not published yet
})(WalletName || (WalletName = {}));
//# sourceMappingURL=types.js.map